{{card.brand}} XXXX-XXXX-XXXX-XXXX-{{card.last4}}


// WEBPACK FOOTER //
// ./src/app/shared/billing-card/billing-card.component.html